/**
 * 连接状态 Store（Zustand）
 * 管理串口连接状态、可用串口列表、当前选中串口和波特率
 */
import { create } from 'zustand';
import type { SerialPortInfo } from '@fluxlab/protocols';

/** 连接状态枚举 */
export type ConnectionState = 'disconnected' | 'connecting' | 'connected' | 'reconnecting';
export type GatewayConnectionState = 'disconnected' | 'connecting' | 'connected';

interface ConnectionStore {
  gatewayState: GatewayConnectionState;
  state: ConnectionState;
  port: string | null;
  baudRate: number;
  ports: SerialPortInfo[];
  error: string | null;

  setGatewayState: (state: GatewayConnectionState) => void;
  setState: (state: ConnectionState) => void;
  setPort: (port: string) => void;
  setBaudRate: (baudRate: number) => void;
  setPorts: (ports: SerialPortInfo[]) => void;
  setError: (error: string | null) => void;
  setConnected: (port: string, baudRate: number) => void;
  setDisconnected: () => void;
  setConnecting: () => void;
}

/** 连接状态 Store（Zustand）：管理网关与串口连接状态、串口列表及波特率 */
export const useConnectionStore = create<ConnectionStore>((set) => ({
  gatewayState: 'disconnected',
  state: 'disconnected',
  port: null,
  baudRate: 115200,
  ports: [],
  error: null,

  setGatewayState: (gatewayState) => set({ gatewayState }),
  setState: (state) => set({ state }),
  setPort: (port) => set({ port }),
  setBaudRate: (baudRate) => set({ baudRate }),
  setPorts: (ports) => set({ ports }),
  setError: (error) => set({ error }),
  setConnected: (port, baudRate) => set({ state: 'connected', port, baudRate, error: null }),
  setDisconnected: () => set({ state: 'disconnected', error: null }),
  setConnecting: () => set({ state: 'connecting', error: null }),
}));
